export default __webpack_public_path__ + "static/store-galaxy.de-94bde877527e3a5502105da0f6ebc0b4.png";